import React, { useState, useEffect, useRef } from 'react';

const LINE_1 = "Let's explore the RNAverse together.";
const LINE_2 = "Bringing the non-coding genome into focus.";
const TYPING_SPEED_MS = 45;
const PAUSE_BEFORE_FOCUS_MS = 400;

const TypewriterTagline: React.FC = () => {
  const [displayedLine1, setDisplayedLine1] = useState('');
  const [typingDone, setTypingDone] = useState(false);
  const [showLine2, setShowLine2] = useState(false);
  const [line2InFocus, setLine2InFocus] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    let charIndex = 0;

    // Phase 1: Type line 1
    intervalRef.current = setInterval(() => {
      if (charIndex < LINE_1.length) {
        charIndex++;
        setDisplayedLine1(LINE_1.slice(0, charIndex));
      } else {
        if (intervalRef.current) clearInterval(intervalRef.current);
        setTypingDone(true);

        // Phase 2: Show line 2 blurred, then bring into focus
        setTimeout(() => {
          setShowLine2(true);
          // Small delay so the blurred state renders before transitioning
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setLine2InFocus(true);
            });
          });
        }, PAUSE_BEFORE_FOCUS_MS);
      }
    }, TYPING_SPEED_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const cursor = (
    <span className="inline-block w-[2px] h-[1.1em] bg-gray-100 ml-0.5 align-middle animate-blink" />
  );

  return (
    <div className="text-center">
      <h2 className="text-xl md:text-2xl font-semibold text-gray-100 mb-1">
        {displayedLine1}
        {!typingDone && cursor}
      </h2>
      <div
        className="text-base md:text-lg text-indigo-300 font-medium mb-6 md:mb-8 min-h-[1.75rem] transition-all duration-[1200ms] ease-out"
        style={{
          opacity: showLine2 ? 1 : 0,
          filter: showLine2
            ? line2InFocus
              ? 'blur(0px)'
              : 'blur(8px)'
            : 'blur(8px)',
        }}
      >
        <p>{LINE_2}</p>
      </div>
    </div>
  );
};

export default TypewriterTagline;
